<template>
  <div class="ma-2">
    <SearchPropertys
      :developmentList="developmentList"
      @developmentSelected="getButtonProperties"
    />
    <LoadingPropertys v-if="loadingAnimation" />
    <NotFoundPropertys
      v-else-if="!this.developmentSelected && !loadingAnimation"
    />
    <div v-else>
      <ToogleContractType v-if="showToogleContractType" class="my-2" />
      <KpisProperties />
      <v-data-table
        :sort-by="['code']"
        :sort-desc="[false]"
        dense
        :headers="headers"
        :items="properties"
        :items-per-page="15"
        class="elevation-1 mx-2 my-8"
        :loading="loading"
        loading-text="Cargando propiedades ..."
        :footer-props="{
          showFirstLastPage: true,
          'items-per-page-text': 'Filas por página:',
          'items-per-page-options': [15, 30, 50, -1]
        }"
      >
        <template v-slot:[`item.contract_status`]="{ item }">
          <v-edit-dialog
            v-if="hasEditable"
            :return-value.sync="item.contract_status"
            large
            @save="
              updateProperty(item._id, {
                contract_status: contractOption_status
              })
            "
            @cancel="cancel"
            @open="open"
          >
            <v-chip
              label
              class="property-contratct-status my-1"
              :color="getColorStatus(item.contract_status)"
              dark
            >
              {{ item.contract_status }}
            </v-chip>
            <template v-slot:input>
              <div class="mt-4 subtitle">Actualizar</div>
              <property-select-contract-status
                v-model="item.contract_status"
                @getOption="getContractStatusOption"
                :selected="item.contract_status"
              />
            </template>
          </v-edit-dialog>
          <v-chip
            v-else
            label
            class="property-contratct-status my-1"
            :color="getColorStatus(item.contract_status)"
            dark
            >{{ item.contract_status }}
          </v-chip>
        </template>
        <template v-slot:[`item.rent_status`]="{ item }">
          <v-edit-dialog
            v-if="hasEditable"
            :return-value.sync="item.rent_status"
            large
            @save="
              updateProperty(item._id, {
                rent_status: rentOption_status
              })
            "
            @cancel="cancel"
            @open="open"
          >
            <v-chip
              label
              class="property-contratct-status my-1"
              :color="getColorStatus(item.rent_status)"
              dark
              >{{ item.rent_status || "indefinido" }}
            </v-chip>
            <template v-slot:input>
              <div class="mt-4 subtitle">Actualizar</div>
              <property-select-rent-status
                v-model="item.rent_status"
                @getOption="getRentStatusOption"
                :selected="item.rent_status"
              />
            </template>
          </v-edit-dialog>
          <v-chip
            v-else
            label
            class="property-contratct-status my-1"
            :color="getColorStatus(item.rent_status)"
            dark
            >{{ item.rent_status }}
          </v-chip>
        </template>
        <template v-slot:[`item.code`]="{ item }">
          <v-row v-if="hasEditable">
            <v-edit-dialog
              :return-value.sync="item.code"
              large
              @save="
                updateProperty(item._id, {
                  code: valueCode
                })
              "
              @cancel="cancel"
              @open="open(item.code)"
            >
              <span v-if="item.code">
                {{ item.code }}
              </span>
              <template v-slot:input>
                <div class="mt-4 title">Actualizar ID</div>
                <span>ID/Nombre</span>
                <v-text-field
                  v-model="valueCode"
                  :disabled="!hasEditable"
                  label="Edit"
                  single-line
                  autofocus
                ></v-text-field>
              </template>
            </v-edit-dialog>
            <v-edit-dialog
              :return-value.sync="item.miscellaneous.mapping_coords"
              large
              @save="
                updateProperty(item._id, {
                  miscellaneous_mappingcoords: item.miscellaneous.mapping_coords
                })
              "
              @cancel="cancel"
              @open="open"
            >
              <v-icon
                v-if="item.code"
                small
                class="margin-icon-code"
                :color="getColor(item)"
              >
                mdi-vector-square-edit
              </v-icon>
              <template v-slot:input>
                <div class="mt-4 title">Actualizar Coordenadas</div>
                <span>Mapping Coords {{ role }}</span>
                <v-text-field
                  v-model="item.miscellaneous.mapping_coords"
                  :disabled="!hasEditable"
                  label="Edit"
                  single-line
                  autofocus
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </v-row>
          <span v-else>
            {{ item.code }}
          </span>
        </template>
        <template v-slot:[`item.pricing.price`]="{ item }">
          <FieldPrice
            :item="item"
            :role="role"
            @updateProperty="
              ({ id, data }) => updateProperty(id, { price: data })
            "
            @cancel="cancel"
            @open="open"
          />
        </template>
        <template v-slot:[`item.rental_pricing.monthly_rent`]="{ item }">
          <FieldPrice
            :item="item"
            :role="role"
            is-rental-price
            @updateProperty="
              ({ id, data }) =>
                updateProperty(id, { rental_pricing: { monthly_rent: data } })
            "
            @cancel="cancel"
            @open="open"
          />
        </template>
        <template v-slot:[`item.features.rooms`]="{ item }">
          <v-edit-dialog
            v-if="hasEditable"
            :return-value.sync="item.features.rooms"
            large
            @save="
              updateProperty(item._id, {
                features_rooms: item.features.rooms
              })
            "
            @cancel="cancel"
            @open="open"
          >
            {{ item.features.rooms }}
            <template v-slot:input>
              <div class="mt-4 subtitle">Actualizar</div>
              <v-text-field
                v-model="item.features.rooms"
                :disabled="!hasEditable"
                label="Edit"
                single-line
                autofocus
              ></v-text-field>
            </template>
          </v-edit-dialog>
          <div v-else>
            {{ item.features.rooms }}
          </div>
        </template>
        <template v-slot:[`item.features.bathrooms`]="{ item }">
          <v-edit-dialog
            v-if="hasEditable"
            :return-value.sync="item.features.bathrooms"
            large
            @save="
              updateProperty(item._id, {
                features_bathrooms: item.features.bathrooms
              })
            "
            @cancel="cancel"
            @open="open"
          >
            {{ item.features.bathrooms }}
            <template v-slot:input>
              <div class="mt-4 subtitle">Actualizar</div>
              <v-text-field
                v-model="item.features.bathrooms"
                :disabled="!hasEditable"
                label="Edit"
                single-line
                autofocus
              ></v-text-field>
            </template>
          </v-edit-dialog>
          <div v-else>
            {{ item.features.bathrooms }}
          </div>
        </template>
        <template v-slot:[`item.building.type`]="{ item }">
          <v-edit-dialog
            v-if="hasEditable"
            :return-value.sync="item.building.type"
            large
            @save="
              updateProperty(item._id, {
                building_type: item.building.type
              })
            "
            @cancel="cancel"
            @open="open"
          >
            {{ item.building.type }}
            <template v-slot:input>
              <div class="mt-4 subtitle">Actualizar</div>

              <v-text-field
                v-model="item.building.type"
                :disabled="!hasEditable"
                label="Edit"
                single-line
                autofocus
              ></v-text-field>
            </template>
          </v-edit-dialog>
          <div v-else>
            {{ item.building.type }}
          </div>
        </template>
        <template v-slot:[`item.building.total`]="{ item }">
          <v-edit-dialog
            v-if="hasEditable"
            :return-value.sync="item.building.total"
            large
            @save="
              updateProperty(item._id, {
                building_construction:
                  item.building && item.building.construction
                    ? item.building.construction
                    : '0',
                building_terrace:
                  item.building && item.building.terrace
                    ? item.building.terrace
                    : '0',
                building_total:
                  item.building && item.building.total
                    ? item.building.total
                    : '0'
              })
            "
            @cancel="cancel"
            @open="open"
          >
            <span
              v-if="
                item.building && item.building.total && item.building.total > 0
              "
            >
              {{ item.building.total }} m<sup>2</sup>
            </span>
            <span v-else> {{ getTotalM2(item.building) }} m<sup>2</sup> </span>

            <template v-slot:input>
              <div class="mt-4 title">Actualizar</div>
              <span>Construcción</span>
              <v-text-field
                v-model="item.building.construction"
                :disabled="!hasEditable"
                label="Edit"
                single-line
                autofocus
              ></v-text-field>
              <span>Terraza</span>
              <v-text-field
                v-model="item.building.terrace"
                :disabled="!hasEditable"
                label="Edit"
                single-line
                autofocus
              ></v-text-field>
              <span>Total</span>
              <v-text-field
                v-model="item.building.total"
                :disabled="!hasEditable"
                label="Edit"
                single-line
                autofocus
              ></v-text-field>
            </template>
          </v-edit-dialog>
          <div v-else>
            <span
              v-if="
                item.building && item.building.total && item.building.total > 0
              "
            >
              {{ item.building.total }} m<sup>2</sup>
            </span>
            <span v-else> {{ getTotalM2(item.building) }} m<sup>2</sup> </span>
          </div>
        </template>
        <template v-slot:[`item.pricePerSquareMeter`]="{ item }">
          <FieldM2
            :item="item"
            :role="role"
            @updateProperty="
              ({ id, data }) => updateProperty(id, { price: data })
            "
            @cancel="cancel"
            @open="open"
          />
        </template>
        <template v-slot:[`item.flex`]="{ item }">
          {{
            item.amenities.find(
              amenity => amenity._id == "6659fb99d7d6c16bd55a9108"
            )
              ? "Sí"
              : "No"
          }}
        </template>
        <template v-slot:[`item.quote`]="{ item }">
          <v-btn
            icon
            color="primary"
            @click="actions(item)"
            style="padding:10px"
            :disabled="developmentSelectedConfig"
          >
            <v-icon>mdi-calculator</v-icon>
          </v-btn>
          <v-btn
            v-if="hasEditable"
            icon
            color="primary"
            @click="onShowDialogEditProperty(item)"
            style="padding:10px"
            :disabled="developmentSelectedConfig"
            small
          >
            <v-icon>mdi-wallpaper</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </div>
    <PropertyModalEdit
      :dialog="showDialogEditProperty"
      :property_id="idEditProperty"
      @setDialog="value => (showDialogEditProperty = value)"
      @closeDialog="onCloseShowDialogEditProperty"
    />
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { GetRealEstateDevelopmentList } from "@/api/real-estate-development-api.js";
import { HEADERS_PROPERTY_TABLE, CONTRACT_TYPE } from "./const.js";

export default {
  name: "TableByDevelopment",
  components: {
    PropertySelectContractStatus: () =>
      import("@/components/property/PropertySelectContractStatus.vue"),
    PropertySelectRentStatus: () =>
      import("@/components/property/PropertySelectRentStatus.vue"),
    PropertyModalEdit: () =>
      import("@/components/property/PropertyModalEdit.vue"),
    KpisProperties: () => import("@/components/property/KpisProperties.vue"),
    ToogleContractType: () =>
      import("@/components/property/ToogleContractType.vue"),
    LoadingPropertys: () =>
      import("@/components/property/LoadingPropertys.vue"),
    NotFoundPropertys: () =>
      import("@/components/property/NotFoundPropertys.vue"),
    SearchPropertys: () => import("@/components/property/SearchPropertys.vue"),
    FieldPrice: () => import("@/components/property/Fields/FieldPrice.vue"),
    FieldM2: () => import("@/components/property/Fields/FieldM2.vue")
  },
  data() {
    return {
      //TypeOfQuote..
      typeOfQuote: "one",
      loadingAnimation: true,
      developmentSelectedConfig: true,
      developmentSelectedTemp: false,
      developmentSelected: false,
      developmentList: [],
      search: "",
      snack: false,
      snackColor: "",
      snackText: "",
      contractOption_status: "",
      rentOption_status: "",
      role: localStorage.getItem("user_role"),
      moduleQuote: localStorage.getItem("moduleQuote"),
      showDialogEditProperty: false,
      idEditProperty: null,
      valueCode: ""
    };
  },
  computed: {
    ...mapState({
      loading: state => state.properties.loading,
      property: state => state.properties.actualItem,
      contractType: state => state.properties.contractType
    }),
    ...mapGetters("properties", {
      properties: "filteredItems"
    }),
    searchTextFilter: {
      get() {
        return this.$store.state.properties.filterText;
      },
      set(newValue) {
        this.$store.commit(
          "properties/setFilterText",
          newValue.trim().toLowerCase()
        );
      }
    },
    // se obtiene el tipo de contrato actual del desarrollo seleccionado
    actualContractType() {
      return (
        this.developmentSelected.contract_type ||
        this.developmentSelectedTemp.contract_type ||
        CONTRACT_TYPE.sale
      );
    },
    // se muestra el toogle de tipo de contrato si el desarrollo tiene ambos tipos de contrato
    showToogleContractType() {
      return this.actualContractType === CONTRACT_TYPE.both;
    },
    // se ajusta el header de la tabla según el tipo de contrato seleccionado
    headers() {
      if (CONTRACT_TYPE.sale === this.contractType)
        return HEADERS_PROPERTY_TABLE.filter(
          ({ value }) =>
            value !== "rent_status" && value !== "rental_pricing.monthly_rent"
        );
      if (CONTRACT_TYPE.rent === this.contractType)
        return HEADERS_PROPERTY_TABLE.filter(
          ({ value }) =>
            value !== "contract_status" && value !== "pricing.price"
        );
      // entonces es ambos
      return HEADERS_PROPERTY_TABLE;
    },
    hasEditable() {
      return this.role === "admin" || this.role === "coordinator";
    }
  },
  created() {
    this.consultRealEstateDevelopmentList();
    //this.consultProperties();
    this.checkAccesQuote();
    //Creación de las columnas para las tablas...
  },

  methods: {
    ...mapActions({
      fetchProperties: "properties/fetchProperties",
      fetchUpdatelProperty: "properties/fetchUpdatelProperty",
      changeContractType: "properties/changeContractType"
    }),
    ...mapMutations({
      setLoading: "properties/setLoading",
      updateActualProperty: "properties/updateActualProperty"
    }),
    checkAccesQuote() {
      if (this.role === "broker") {
        if (this.moduleQuote) {
          if (this.moduleQuote === "on") {
            this.headers.push({ text: "Acciones", value: "quote" });
          }
        }
      }
      if (this.role === "admin") {
        this.headers.push({ text: "Acciones", value: "quote" });
      }
    },
    consultRealEstateDevelopmentList() {
      let self = this;
      GetRealEstateDevelopmentList().then(res => {
        self.developmentList = res.RealEstateDevelopment;
        self.consultProperties();
      });
    },
    actions(item) {
      //Verificar si es Admin o es broker...
      let developmentTemp;
      //Verificar si es admin o es broker..
      if (this.developmentSelected.code) {
        developmentTemp = this.developmentSelected.code;
      } else {
        developmentTemp = this.developmentSelected;
      }
      let quote;
      if (this.typeOfQuote === "one") {
        quote = "quote";
      }
      if (this.typeOfQuote === "two") {
        quote = "quoteAdvanced";
      }
      this.$router.push(
        `/${this.role}/real-estate-development/${quote}/${developmentTemp}/${item._id}`
      );
    },
    getColor(item) {
      if (
        item.miscellaneous &&
        item.miscellaneous.mapping_coords &&
        item.miscellaneous.mapping_coords.length > 0
      ) {
        return "";
      } else {
        return "grey lighten-2";
      }
    },
    //Modificar la entrada por aqui...
    //Se puede entrar por los props y por la ruta..
    //Tener en cuenta que en el cotizador necesita poder pasar datos de la propiedad...
    consultProperties() {
      let self = this;
      self.setLoading(true);

      self.developmentSelected = this.firsMove();
      self.developmentSelectedTemp = self.developmentSelected;
      if (self.developmentSelectedTemp) {
        this.fetchProperties(self.developmentSelected.code)
          .then(() => {})
          .finally(() => {
            self.setLoading(false);
            self.loadingAnimation = false;
            //Vamos a disparar un metodo para que ejecute activar el boton de la calculadora
            //Se le tiene que pasar el desarrollo y no las propiedades del desarrollo
            self.activateCalculator(self.developmentSelectedTemp);
          });
      }
      self.loadingAnimation = false;
    },
    //Recibira una propiedad para validar si activar o no la calculadora
    activateCalculator(desarrollo) {
      this.updateConfigDevelopment(desarrollo);
    },
    //Ultimo en terminar .... Pendiente....
    updateConfigDevelopment(selected) {
      this.developmentSelectedConfig = true;
      if (selected) {
        if (selected.miscellaneous) {
          if (selected.miscellaneous.quote) {
            if (selected.miscellaneous.quote.active) {
              if (selected.miscellaneous.quote.active === "on") {
                this.developmentSelectedConfig = false;
                this.typeOfQuote = "one";
              }
            }

            if (selected.miscellaneous.quote.active_two) {
              if (selected.miscellaneous.quote.active_two === "on") {
                this.developmentSelectedConfig = false;
                this.typeOfQuote = "two";
              }
            }
          }
        }
      }
    },
    //Aqui va el codigo para poder saber cual es la primera seleccion de las propiedades..
    firsMove() {
      //Verificar si hay un desarrollo en la ruta... de lo contrario se selecciona la primera opcion de la lista de desarrollos..
      //Tener en cuenta que prodria ser una de las propiedades en favoritos.. de ser asi debe de escoger el primero de la lista..
      if (this.$route.params.realEstateCode !== undefined) {
        //Buscar y traer el objeto...
        return this.searchProperty(this.$route.params.realEstateCode);
        ///Validar por si se pone la direccion incorrecta...
      } else {
        //Checar favoritos...
        return this.developmentList[0];
      }
    },

    searchProperty(find) {
      const result = this.developmentList.filter(l => {
        if (l.code === find) {
          return l;
        }
      });

      if (result.length !== 0) {
        return result[0];
      } else {
        return false;
      }
    },
    getButtonProperties(item) {
      this.developmentSelected = item;
      if (item) {
        this.developmentSelectedTemp = this.searchProperty(item);
        this.updateConfigDevelopment(this.developmentSelectedTemp);
        this.consultPropertiesUpdate(item);

        this.changeContractType(
          this.developmentSelectedTemp.contract_type === CONTRACT_TYPE.both
            ? CONTRACT_TYPE.sale
            : this.developmentSelectedTemp.contract_type
        );
      } else {
        this.developmentSelected = this.developmentSelectedTemp;
        //Se selecciona el ultimo desarrollo que escogio
      }
    },

    consultPropertiesUpdate(code) {
      this.setLoading(true);
      this.loadingAnimation = true;
      this.fetchProperties(code)
        .then(() => {})
        .finally(() => {
          this.setLoading(false);
          this.loadingAnimation = false;
        });
    },
    updateProperty(propertyId, data) {
      this.handleUpdateProperty(propertyId, data);
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Canceled";
    },
    open(code) {
      this.valueCode = code;
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Dialog opened";
    },
    handleUpdateProperty(propertyId, propertyData) {
      // una vez cambiado la propiedad actual, actualizar el valor en Vuex
      let data = {
        propertyId,
        property: propertyData
      };

      let self = this;
      this.$snotify.async(
        "Actualizando propiedad",
        "Actualizando ...",
        () =>
          new Promise((resolve, reject) => {
            this.fetchUpdatelProperty(data)
              .then(() => {
                resolve({
                  title: "Propiedad editada",
                  body: "La propiedad se ha editado correctamente.",
                  config: {
                    closeOnClick: true,
                    titleMaxLength: 30,
                    timeout: 1000
                  }
                });
              })
              .catch(err => {
                reject({
                  title: "Error!!!",
                  body: `Ocurrio un problema al actualizar la propiedad. ${err}`,
                  config: {
                    closeOnClick: true,
                    timeout: 2000
                  }
                });
              })
              .finally(() => self.setLoading(false));
          })
      );
    },
    getContractStatusOption(option) {
      const self = this;
      if (option) {
        self.contractOption_status = option.value;
      }
      // this.updateProperty(propertyId, { contract_status: option });
    },
    getRentStatusOption(option) {
      const self = this;
      if (option) {
        self.rentOption_status = option.value;
      }
    },
    getTotalM2(item) {
      if (item.construction && item.terrace) {
        let result = parseFloat(item.construction) + parseFloat(item.terrace);
        return result.toFixed(2);
      } else if (item.construction) {
        return item.construction;
      } else if (item.terrace) {
        return item.terrace;
      } else {
        return 0;
      }
    },
    onShowDialogEditProperty(property) {
      this.idEditProperty = property._id;
      this.showDialogEditProperty = true;
    },
    onCloseShowDialogEditProperty() {
      this.idEditProperty = null;
      this.showDialogEditProperty = false;
    },
    getColorStatus(status) {
      switch (status) {
        case "disponible":
          return "green darken-1";
        case "reservado":
          return "orange darken-1";
        case "vendido":
        case "rentado":
          return "red darken-1";
        default:
          return "grey";
      }
    }
  }
};
</script>
<style>
.property-contratct-status {
  cursor: pointer;
  text-transform: uppercase;
  font-weight: bold;
}
</style>
